<template>
  <div class="checkboxes-wrapper checkboxes-wrapper--single" :class="{ 'error': showFormError,  'required': required }">
    <p class="checkboxes__title" v-if="displayLabel">{{ label }}</p>
    <p class="field-description" v-if="fieldData.description" v-html="fieldData.description"/>
    <p class="forms__help-text" v-if="helpText.length > 0">{{ helpText }}</p>
    <label class="checkbox-container">
      <input type="checkbox"
        :id="fieldData.id"
        :name="fieldData.name"
        v-model="value"
      />
      <span class="checkmark"></span>
      <span class="checkbox__title" v-if="isHtml" v-html="label"></span>
      <span class="checkbox__title" v-else>{{ label }}</span>
    </label>
    <p class="forms__error-message" v-if="showFormError" v-t="'errors.required_field'" role="alert"/>
  </div>
</template>
<script>
import AbstractField from "@/util/AbstractField";

export default {
  name: "checkbox",
  mixins: [AbstractField],
  computed: {
    displayLabel() {
      if(this.fieldData.crm_id == "WK_eNews") {
        return false;
      }

      return true;
    },
    isHtml() {
      return this.fieldData.crm_id == "WK_eNews";
    }
  }
};
</script>